import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { LOV_DOCTYPE, LovService } from '../../../services/lov.service';
import { Override } from '../../../app-decorators';
import { IObject } from '@type_definitions/datatypes';
import { GaMessageService } from '../../../message/ga-message.service';
import { AuthService } from '../../../services/auth/auth.service';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'upload-order-document-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class UploadOrderDocumentActionComponent  extends BaseReportActionsDialog implements OnInit {
  public model:{
    documentType?:string;
    description?:string;
    file?:string;
  };

  private documentTypeField: IExtraFieldConfigurationObject;
  private fileField: IExtraFieldConfigurationObject;
  private actionParams: IObject;

  constructor(
    private formlyService: GaFormlyService,
    private lovService: LovService,
    private messageService: GaMessageService,
    private authService: AuthService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  @Override(BaseReportActionsDialog)
  public execute(): void {
    this.executing = true;
    this.validate()
      .then(() => {
        // indicate that file upload field can start upload
        this.fileField.templateOptions.startUpload.emit({
          documentType: this.model.documentType,
          documentDescription: this.model.description
        });
      })
      .catch(() => {
        this.executing = false;
      });
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.documentTypeField = this.formlyService.aSelect('documentType', 'Document Type')
        .isRequired()
        .withLabelProp('description')
        .withValueProp('code')
        .build(),
      this.formlyService.anInput('description', 'Description')
        .build(),
      this.fileField = this.formlyService.aFileUpload('file', 'File')
        .withUrl(this.authService.authenticatedUrl(`rest/reports/${this.reportId}/actions/${this.action.id}/documents`))
        .withExtraOptions({
          templateOptions: {
            icon: 'fa fa-folder-open-o',
            uploadContext: {
              documentType: this.model.documentType,
              documentDescription: this.model.description
            },
            autoUpload: false,
            onUploadDone: this.onUploadDone,
            onUploadFailed: this.onUploadFailed
          }
        })
        .isRequired()
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(this.documentTypeField, this.lovService.list(LOV_DOCTYPE));
  }

  private onUploadDone = (documentId: string): void => {
    this.actionParams = { documentId };
    this.executing = false;
    this.onSave.emit(this.actionParams);
  };

  private onUploadFailed = (): void => {
    this.executing = false;
  };
}